import { Helmet } from "react-helmet";
import PropTypes from "prop-types";

export default function SEO({ url = "https://markdownconverter.online/", image = "https://markdownconverter.online//icons/md-converter-1024x1024.pn" }) {
  const title = "Markdown Converter Pro - Instant PDF, Word & Google Docs Export";
  const description = "Free online Markdown converter with real-time preview. Instantly export to PDF, Microsoft Word (DOCX), and Google Docs. Perfect for developers, writers, and teams.";
  const keywords = "markdown converter, export to pdf, convert to word doc, google docs integration, online document converter, markdown editor";

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content="@yourhandle" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Canonical */}
      <link rel="canonical" href={url} />

      {/* Structured Data */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "Markdown Converter Pro",
            "applicationCategory": "DeveloperApplication",
            "operatingSystem": "Web",
            "softwareVersion": "2.0",
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.8",
              "ratingCount": "1500",
              "bestRating": "5"
            },
            "offers": {
              "@type": "Offer",
              "price": "0.00",
              "priceCurrency": "USD",
              "availability": "https://schema.org/InStock"
            },
            "image": "${image}",
            "description": "${description}",
            "publisher": {
              "@type": "Organization",
              "name": "Markdown Converter Pro",
              "logo": {
                "@type": "ImageObject",
                "url": "https://markdownconverter.online/icons/md-converter-1024x1024.png"
              }
            }
          }
        `}
      </script>
    </Helmet>
  );
}

SEO.propTypes = {
  url: PropTypes.string,
  image: PropTypes.string
};